import { referrerURL } from '@/utils/referrer';

export const WALLET_READY_MESSAGE = 'wallet:ready';

export const WALLET_RESIZE_MESSAGE = 'wallet:resize';

export const WALLET_DISCONNECT_MESSAGE = 'wallet:disconnect';

export const WALLET_NAVIGATE_MESSAGE_TYPE = 'wallet:navigate';

export const WALLET_WIDGET_CONFIG_MESSAGE_TYPE = 'wallet:widget:config';

type Message = typeof WALLET_DISCONNECT_MESSAGE;

type MessageHandler = (event: MessageEvent) => void;

type MessageFilter = (event: MessageEvent) => boolean;

export function createMessageHandler(
  filter: Message | MessageFilter,
  handle: MessageHandler,
): MessageHandler {
  return (event) => {
    const messageInvalid = !(typeof filter === 'string'
      ? event.data === filter
      : filter(event));

    if (event.origin !== new URL(referrerURL).origin || messageInvalid) {
      return;
    }

    handle(event);
  };
}
